// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gfag","colBig":"styles_colBig__HOkEJ","colSmall":"styles_colSmall__3jRWT"};